import React, { useState } from "react";
import { Button } from "./ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";
import { Check, Copy } from "lucide-react";

const EmailCopyButton = ({ emails = [] }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (emails.length === 0) return;

    try {
      await navigator.clipboard.writeText(emails.join("; "));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy emails:", err);
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={handleCopy}
            variant="outline"
            disabled={emails.length === 0}
            className="flex items-center gap-2"
          >
            {copied ? (
              <>
                <Check className="h-4 w-4" />
                <span>Skopírované!</span>
              </>
            ) : (
              <>
                <Copy className="h-4 w-4" />
                <span>Kopírovať emailové adresy</span>
              </>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Kopírovať všetky emailové adresy pre hromadné odoslanie</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default EmailCopyButton;
